import { useState } from "react";
import { Button, Image, Input, Radio, Toast } from "antd-mobile";
import { TOASTDURATION } from "../../common/Utils";
import { feexPayCreate } from "../../common/ApiAction";
import {useNavigate} from "react-router-dom";

const TogoFeexPay = () => {
    // 状态管理 - 包含所需的所有参数
    const [phoneNumber, setPhoneNumber] = useState<string>('');
    const [amount, setAmount] = useState<string>('');
    const [networkType, setNetworkType] = useState<string>('');
    const [payRemark, setPayRemark] = useState<string>('');
    const navigate = useNavigate()
    const phonePrefix = phoneNumber.trim().slice(0, 3);

    const submitAction = () => {
        // 必填项验证
        if (!phoneNumber.trim()) {
            Toast.show({ content: "Please enter Numéro payement", duration: TOASTDURATION });
            return;
        }
        if (phonePrefix !== '228') {
            Toast.show({ content: "Numéro payement must start with 228", duration: TOASTDURATION });
            return;
        }
        if (!amount.trim()) {
            Toast.show({ content: "Please enter Montant", duration: TOASTDURATION });
            return;
        }
        if (!networkType) {
            Toast.show({ content: "Please select network type", duration: TOASTDURATION });
            return;
        }
        if (parseInt(amount) < 100) {
            Toast.show({ content: "Montant can not less 100", duration: TOASTDURATION });
            return;
        }
        Toast.show({ icon: 'loading', content: 'Processing...', duration: 0 });

        // 准备提交数据
        const data: any = {
            phoneNumber: phoneNumber.trim(),
            amount: amount.trim(),
            countryCode: 'togo',
            customData: payRemark.trim(),
            networkType: networkType,
        };

        // 调用API提交数据
        feexPayCreate(data).then((res: any) => {
            Toast.clear();
            if (parseInt(res.code) !== 200 ) {
                Toast.show({ icon: 'fail', content: res.message || res.msg, duration: TOASTDURATION });
            } else {
                // 清空表单
                setPhoneNumber('');
                setAmount('');
                setNetworkType('');
                Toast.show({ icon: 'success', content: "Payment initiated successfully!", duration: TOASTDURATION });
                navigate('/user/pay/success?from=/feex/togo')
            }
        }).catch((error: any) => {
            Toast.clear();
            Toast.show({ icon: 'fail', content: "Payment failed, please try again", duration: TOASTDURATION });
        });
    };

    return (
        <div style={{ width: '100%', display: "flex", flexDirection: "column", alignItems: "center" }}>
            <div>
                <Image src={require('../../assets/icon_ego_logo.jpg')} style={{ width: 100 }} />
            </div>
            <div style={{ borderRadius: 8, padding: '50px 0 20px 0', border: "solid #08ad58 1px", width: '90%', marginTop: 15, display: "flex", flexDirection: "column", alignItems: "center" }}>
                <span style={{ fontSize: 20, fontWeight: "bold", marginBottom: 30 }}>Payment Center</span>
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "start", width: '100%' }}>
                    {/* 手机号输入框 - 必填 */}
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginTop: 20, marginLeft: 10 }}>
                        <span style={{ fontSize: 12, marginRight: 10, width: 100 }}>Numéro payement:</span>
                        <Input value={phoneNumber} onChange={val => setPhoneNumber(val)} type={'number'} style={{ "--font-size": '12px', width: '45%', border: "solid #cccccc 1px" }} placeholder={"Enter Numéro payement"} />
                    </div>

                    {/* 金额输入框 - 必填 */}
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginTop: 20, marginLeft: 10 }}>
                        <span style={{ fontSize: 14, marginRight: 10, width: 100 }}>Montant:</span>
                        <Input value={amount} onChange={val => setAmount(val)} type={'number'} style={{ "--font-size": '10px', width: '45%', border: "solid #cccccc 1px" }} placeholder={"Enter Montant"} />
                    </div>

                    {/*/!* 名字输入框 - 选填 *!/*/}
                    {/*<div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginTop: 20, marginLeft: 10 }}>*/}
                    {/*    <span style={{ fontSize: 14, marginRight: 10, width: 100 }}>First Name:</span>*/}
                    {/*    <Input value={firstName} onChange={val => setFirstName(val)} type={'text'} style={{ "--font-size": '10px', width: '45%', border: "solid #cccccc 1px" }} placeholder={"Optional"} />*/}
                    {/*</div>*/}

                    {/*/!* 姓氏输入框 - 选填 *!/*/}
                    {/*<div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginTop: 20, marginLeft: 10 }}>*/}
                    {/*    <span style={{ fontSize: 14, marginRight: 10, width: 100 }}>Last Name:</span>*/}
                    {/*    <Input value={lastName} onChange={val => setLastName(val)} type={'text'} style={{ "--font-size": '10px', width: '45%', border: "solid #cccccc 1px" }} placeholder={"Optional"} />*/}
                    {/*</div>*/}

                    {/* 支付备注 - 必填 */}
                    <div style={{display: "flex", flexDirection: "row", alignItems: "center", marginTop: 20, marginLeft: 10}}>
                        <span style={{fontSize: 14, marginRight: 10, width: 100}}>Numéro Identifiant:</span>
                        <Input value={payRemark} onChange={val => setPayRemark(val)} type={'text'} style={{"--font-size": '10px', width: '45%', border: "solid #cccccc 1px"}} placeholder={"Numéro Identifiant"}/>
                    </div>

                    {/* 网络类型选择框 - 必填 */}
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginTop: 20, marginLeft: 10 }}>
                        <span style={{ fontSize: 14, marginRight: 10, width: 100 }}>Network Type:</span>
                        <Radio.Group value={networkType} onChange={val => setNetworkType(val as string)}>
                            <Radio style={{ '--font-size': '14px', '--gap': '6px', '--icon-size': '15px' }} value="MOOV">MOOV</Radio>
                            <Radio style={{ '--font-size': '14px', '--gap': '6px', '--icon-size': '15px', marginLeft: 10 }} value="TOGOCOM">TOGOCOM</Radio>
                        </Radio.Group>
                    </div>

                </div>
            </div>

            {/* 提交按钮 */}
            <div>
                <Button shape='rounded' style={{ backgroundColor: '#08ad58', color: '#FFF', marginTop: 50, paddingLeft: 30, paddingRight: 30 }} onClick={submitAction}>Confirm and Proceed</Button>
            </div>
        </div>
    );
};

export default TogoFeexPay;
